<template>
    <div>
        <!-- <div class="fx-header goback">
            <p>运费</p>
        </div> -->
		<div class="store-name">
			<span>
				<i class="el-icon-back" @click="goBack"></i>
			</span>
			<span>{{id ? '编辑' : '新增'}}运费模板(特殊商品)</span>
		</div>
        <div class="container">
            <div style="display:flex;flex-direction:column;height:100%;">
				<div class="template-name">
					<span style="color:#F03939;">*</span>模板名称:<el-input size='mini' class="name-input" v-model="templateName" placeholder="不超过50个字" maxlength="50"></el-input>
					<el-checkbox v-model="calcgiftFlag">赠品是否计算运费</el-checkbox>
					<span class="edit-time" v-if="modifyDate">上次编辑时间:{{modifyDate}}</span>
				</div>
				<div style="margin:10px 0">
					<el-button size="small" type="primary" plain class="btn fx-btn" style="margin-left: 0px" @click="multiDdelete">删除</el-button>
					<el-button size="small" type="primary" plain class="btn fx-btn" @click="multiSet">批量设置</el-button>
					<el-input size='small' class="search-input" v-model="searchKey" placeholder="请输入商品编码/商品名称/第三方编号/商品类别">
						<el-button slot="append" icon="el-icon-search" @click="searchClick"></el-button>
					</el-input>
				</div>
				<div style="display:flex;flex-direction:column;flex:1">
					<el-table
						class="grid-content"
						:data="areaTableData"
						border
						:height="tableHeight"
						:row-style="rowShowStyle"
						ref="table"
						:span-method="objectSpanMethod"
						:cell-class-name="checkboxClassName"
						@select="handleSelectionChange"
						@select-all="handleSelectionChange"
					>
						<el-table-column
							prop="staffName"
							label="配送区域"
							width="300"
							align="center">
							<template slot="header">
								<div>配送区域<i class="el-icon-circle-plus-outline area-add" @click="addClick"></i>
								</div>
							</template>
							<template slot-scope="scope">
								<el-button size='mini' @click="editTree(scope.row, scope.$index)" style="padding:0 20px;line-height:20px;white-space:normal;" type='text' :title="scope.row.areaname">{{scope.row.showname}}</el-button>
							</template>
						</el-table-column>
						<el-table-column
							type="selection"
							align="center"
							width="50">
						</el-table-column>
						<el-table-column
							prop="productName"
							label="商品"
							align="center">
							<template slot-scope="scope">
								<div v-if="scope.row.productName">{{scope.row.productName}}</div>
								<div v-else>
									<el-button size='mini' @click="addProduct(scope.row, scope.$index)" type="text">+添加商品</el-button>
								</div>
							</template>
						</el-table-column>
						<el-table-column
							prop="categoryName"
							label="商品类别"
							align="center">
						</el-table-column>
						<el-table-column
							prop="transportMode"
							label="运输方式"
							align="center"
							min-width="150">
							<template slot-scope="scope">
								<span v-if="scope.row.transportMode === 1 && scope.row.productName">常温运输</span>
								<span v-if="scope.row.transportMode === 2 && scope.row.productName">冷链运输</span>
							</template>
						</el-table-column>
						<el-table-column
							prop="productAttrplanName"
							label="规格"
							align="center">
						</el-table-column>
						<el-table-column
							prop="pricingType"
							label="计费方式"
							align="center">
							<template slot-scope="scope">
								<div v-if="scope.row.productName">
									<el-select v-model="scope.row.pricingType" size='small' :disabled="scope.row.productId === 0 && scope.row.productAttrplanId === 0 && scope.row.pricingType === 3" placeholder="请选择">
										<el-option :value="3" label="计重"></el-option>
										<el-option :value="4" label="计件：阶梯件数"></el-option>
										<el-option :value="8" label="计件：固定件数"></el-option>
									</el-select>
								</div>
							</template>
						</el-table-column>
						<el-table-column
							prop="pricingType"
							label="计费规则"
							width="550"
							align="center">
							<template slot-scope="scope">
								<div class="flex-two table-box" v-if="scope.row.productName">
									<div v-if="scope.row.pricingType === 4">
										<div class="rule-box two-box">
											<div v-for="(childItem, childIndex) in scope.row.freightTemplatePricingDTOList" :key="childIndex" class="two-wrap">
												<div class="step-box">
													商品于
													<el-input size='mini' class="cell-input" type='number' v-model="childItem.minValue" disabled></el-input>
													件（含）~
													<el-input size='mini' class="cell-input" type='number' v-model="childItem.maxValue" :disabled="childIndex !== scope.row.freightTemplatePricingDTOList.length-1" @change="stepMoneyChange(childIndex, scope.$index,'maxValue')"></el-input>
													件（不含），收
													<el-input size='mini' class="cell-input" :class="{'input-error': childItem.isError === 1}" type='number' v-model="childItem.freightMoney" @change="stepMoneyChange(childIndex, scope.$index,'freightMoney')"></el-input>
													元
												<el-button size='mini' v-if='childIndex === scope.row.freightTemplatePricingDTOList.length-1 && childItem.maxValue && parseFloat(childItem.maxValue) > parseFloat(childItem.minValue)' class="time-btn" icon="el-icon-plus" circle @click="addTimeClick(childItem.maxValue, scope.$index)"></el-button>
												<el-button size='mini' v-if='scope.row.freightTemplatePricingDTOList.length > 1 && childIndex === scope.row.freightTemplatePricingDTOList.length-1' class="time-btn" icon="el-icon-minus" circle @click="delTimeClick(childIndex, scope.$index)"></el-button></div>
											</div>
											<div>该商品金额满<el-input size='mini' class="cell-input" type='number' v-model="scope.row.freeMoney" @change="freeMoneyChange(scope.$index)"></el-input>元，免运费。</div>
										</div>
									</div>
									<div v-if="scope.row.pricingType === 3" style="line-height:35px;padding:0 5px;text-align:left">
										商品于0kg（含）~
										<el-input size='mini' class="cell-input" type='number' v-model="scope.row.freightTemplatePricingDTOList[0].maxValue" @change="weightMoneyChange(scope.$index,'maxValue')"></el-input>
										kg（含），收
										<el-input size='mini' class="cell-input" type='number' v-model="scope.row.freightTemplatePricingDTOList[0].freightMoney" @change="weightMoneyChange(scope.$index,'freightMoney')"></el-input>
										元，每增加
										<el-input size='mini' class="cell-input" type='number' v-model="scope.row.freightTemplatePricingDTOList[0].stepValue" @change="weightMoneyChange(scope.$index,'stepValue')"></el-input>
										kg，加收
										<el-input size='mini' class="cell-input" type='number' v-model="scope.row.freightTemplatePricingDTOList[0].stepMoney" @change="weightMoneyChange(scope.$index,'stepMoney')"></el-input>
										元
										<el-radio v-model="scope.row.topOffRadio" label="1">不减免</el-radio><el-radio v-model="scope.row.topOffRadio" label="2">减免</el-radio>
										<div>该商品金额满<el-input size='mini' class="cell-input" type='number' v-model="scope.row.freeMoney" @change="freeMoneyChange(scope.$index)"></el-input>元，免运费。</div>
									</div>
									<div v-if="scope.row.pricingType === 8" style="line-height:35px;padding:0 5px;text-align:left">
										商品于0件（含）~
										<el-input size='mini' class="cell-input" type='number' v-model="scope.row.freightTemplatePricingDTOList[0].maxValue" @change="weightMoneyChange(scope.$index,'maxValue')"></el-input>
										件（含），收
										<el-input size='mini' class="cell-input" type='number' v-model="scope.row.freightTemplatePricingDTOList[0].freightMoney" @change="weightMoneyChange(scope.$index,'freightMoney')"></el-input>
										元，每增加
										<el-input size='mini' class="cell-input" type='number' v-model="scope.row.freightTemplatePricingDTOList[0].stepValue" @change="weightMoneyChange(scope.$index,'stepValue')"></el-input>
										件，加收
										<el-input size='mini' class="cell-input" type='number' v-model="scope.row.freightTemplatePricingDTOList[0].stepMoney" @change="weightMoneyChange(scope.$index,'stepMoney')"></el-input>
										元
										<el-radio v-model="scope.row.topOffRadio" label="1">不减免</el-radio><el-radio v-model="scope.row.topOffRadio" label="2">减免</el-radio>
										<div>该商品金额满<el-input size='mini' class="cell-input" type='number' v-model="scope.row.freeMoney" @change="freeMoneyChange(scope.$index)"></el-input>元，免运费。</div>
									</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column label="操作" width="220" align="center">
							<template slot-scope="scope">
								<el-button type='text' size="mini" @click="deleteProduct(scope.$index)" v-if="scope.row.productName">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
            </div>
            <el-dialog
                title="选择配送区域"
                :visible.sync="showTree"
                class="dialog-title"
                width="800px"
                :close-on-click-modal="false">
                <tree @dialogClose="dialogClose" :delList='delList' :disabled='isDisabled' @addArea='addArea' :typeRadio='typeRadio' :treeId='treeId' :freightId='id' :isCheckedArrHalf='checkedArrHalf' :isCheckedArr='checkedArr' :isAdd='addTree' v-if="showTree"/>
            </el-dialog>
            <el-dialog top='60px' class="pull-dialog" title="添加商品" :before-close='cancelProduct' :visible.sync="addProductModel" width='1000px' :close-on-click-modal="false">
                <addProduct v-if='addProductModel' :targettype='targettype' :ids='planIds' @add='addHandle' @cancel='cancelProduct'></addProduct>
            </el-dialog>
			<el-dialog title="批量设置" class="confirm-dialog" top='60px' @close="multiClose" :visible.sync="multiSetModel" width='600px' :close-on-click-modal="false">
				<div class="dialog-container">
					<div class="input-box">
						<span style="margin-right:20px;">字段</span>
						<el-select v-model="multiType" class="input-span" size='mini'>
							<el-option :value="3" label="计重"></el-option>
							<el-option :value="8" label="计件：固定件数"></el-option>
							<el-option :value="4" label="计件：阶梯件数"></el-option>
						</el-select>
					</div>
					<div class="input-box">
						<div class="change-title">设置</div>
						<div class="change-right">
							<div v-if="multiType === 3" style="line-height:35px;padding:0 5px;text-align:left">
								商品于0kg（含）~
								<el-input size='mini' class="cell-input" type='number' v-model="multiObj.maxValue" @change="multiObjChange('maxValue')"></el-input>
								kg（含），收
								<el-input size='mini' class="cell-input" type='number' v-model="multiObj.freightMoney" @change="multiObjChange('freightMoney')"></el-input>
								元，每增加
								<el-input size='mini' class="cell-input" type='number' v-model="multiObj.stepValue" @change="multiObjChange('stepValue')"></el-input>
								kg，加收
								<el-input size='mini' class="cell-input" type='number' v-model="multiObj.stepMoney" @change="multiObjChange('stepMoney')"></el-input>
								元
								<div><el-radio v-model="multiObj.topOffRadio" label="1">不减免</el-radio><el-radio v-model="multiObj.topOffRadio" label="2">减免</el-radio></div>
								<div>该商品金额满<el-input size='mini' class="cell-input" type='number' v-model="multiObj.freeMoney" @change="multiObjChange('freeMoney')"></el-input>元，免运费。</div>
							</div>
							<div v-if="multiType === 8" style="line-height:35px;padding:0 5px;text-align:left">
								商品于0件（含）~
								<el-input size='mini' class="cell-input" type='number' v-model="multiObj.maxValue" @change="multiObjChange('maxValue')"></el-input>
								件（含），收
								<el-input size='mini' class="cell-input" type='number' v-model="multiObj.freightMoney" @change="multiObjChange('freightMoney')"></el-input>
								元，每增加
								<el-input size='mini' class="cell-input" type='number' v-model="multiObj.stepValue" @change="multiObjChange('stepValue')"></el-input>
								件，加收
								<el-input size='mini' class="cell-input" type='number' v-model="multiObj.stepMoney" @change="multiObjChange('stepMoney')"></el-input>
								元
								<div><el-radio v-model="multiObj.topOffRadio" label="1">不减免</el-radio><el-radio v-model="multiObj.topOffRadio" label="2">减免</el-radio></div>
								<div>该商品金额满<el-input size='mini' class="cell-input" type='number' v-model="multiObj.freeMoney" @change="multiObjChange('freeMoney')"></el-input>元，免运费。</div>
							</div>
							<div v-if="multiType === 4" style="line-height:35px;">
								<div v-for="(childItem, childIndex) in multiData.multiList" :key="childIndex" class="two-wrap">
									<div class="step-box">
										商品于
										<el-input size='mini' class="cell-input" type='number' v-model="childItem.minValue" disabled></el-input>
										件（含）~
										<el-input size='mini' class="cell-input" type='number' v-model="childItem.maxValue" :disabled="childIndex !== multiData.multiList.length-1" @change="multiListChange(childIndex,'maxValue')"></el-input>
										件（不含），收
										<el-input size='mini' class="cell-input" :class="{'input-error': childItem.isError === 1}" type='number' v-model="childItem.freightMoney" @change="multiListChange(childIndex, 'freightMoney')"></el-input>
										元
									<el-button size='mini' v-if='childIndex === multiData.multiList.length-1 && childItem.maxValue && parseFloat(childItem.maxValue) > parseFloat(childItem.minValue)' class="time-btn" icon="el-icon-plus" circle @click="multiAddClick(childItem.maxValue)"></el-button>
									<el-button size='mini' v-if='multiData.multiList.length > 1 && childIndex === multiData.multiList.length-1' class="time-btn" icon="el-icon-minus" circle @click="multiDelClick(childIndex)"></el-button></div>
								</div>
								<div>该商品金额满<el-input size='mini' class="cell-input" type='number' v-model="multiData.freeMoney" @change="multiFChange"></el-input>元，免运费。</div>
							</div>
						</div>
					</div>
					<div class="btn-box" style="margin-top:30px;text-align:center">
						<el-button size="small" class="btn" plain type="primary" @click="multiSetModel = false">取消</el-button>
						<el-button size="small" class="btn" plain type="primary" @click="saveMulti">确认</el-button>
					</div>
				</div>
			</el-dialog>
        </div>
		<div class="btn-feight-box" v-if="AuthorityList['01_0003_0001_00']">
			<el-button size='small' class="fx-big-btn" type="primary" @click="submitForm">保存</el-button>
		</div>
    </div>
</template>

<script>
import tree from '@/components/freight/tree.vue'
import addProduct from '@/components/freight/addProduct.vue'
import { codeToCity } from '@/js/location/codeToCtiy.js'
export default {
	name: 'freight',
	components: {
		tree, addProduct
	},
	data () {
		return {
			AuthorityList: {
				'01_0003_0001_00': false,
				'01_0003_0002_00': false,
				'01_0003_0003_00': false,
				'01_0003_0004_00': false
			},
			provinceList: [
				'110000',
				'120000',
				'130000',
				'140000',
				'150000',
				'210000',
				'220000',
				'230000',
				'310000',
				'320000',
				'330000',
				'340000',
				'350000',
				'360000',
				'370000',
				'410000',
				'420000',
				'430000',
				'440000',
				'450000',
				'460000',
				'500000',
				'510000',
				'520000',
				'530000',
				'540000',
				'610000',
				'620000',
				'630000',
				'640000',
				'650000',
				'710000',
				'810000',
				'820000',
				'900000'
			],
			isDisabled: true,
			isChanged: false,
			sftid: null,
			totalCount: 0,
			targettype: 1,
			week: [1, 2, 3, 4, 5, 6, 7],
			selfpickTimes: [{ val: ['08:30', '17:30'] }],
			buyerselfpickflag: false,
			samedayflag: true,
			delList: [],
			id: '',
			treeId: '',
			addProductModel: false,
			addTree: false,
			isAdd: false,
			showTree: false,
			areaTableData: [],
			deliveryflag: true,
			selfPickFlag: true,
			typeRadio: 0,
			freightType: 1,
			effectText: '',
			page: {
				size: 20,
				num: 1
			},
			productTableData: [],
			shopTableData: [],
			tableHeight: '100%',
			selfpickMoney: 0,
			form: {
				deliveryWay: [0],
				sendamount: 0,
				name: '',
				templatetype: 0,
				freighttype: 0
			},
			rules: {
				name: [
					{ required: true, message: '请输入模板名称', trigger: 'blur' }
				],
				sendamount: [
					{ required: true, message: '请输入起订金额', trigger: 'blur' }
				],
				templatetype: [
					{ required: true, message: '请选择模板类型', trigger: 'change' }
				],
				freighttype: [
					{ required: true, message: '请选择计费方式', trigger: 'change' }
				]
			},
			templateName: '',
			calcgiftFlag: false,
			checkedArr: {},
			checkedArrHalf: {},
			editIndex: null,
			modifyDate: '',
			addIndex: -1,
			planIds: [],
			selectIds: [],
			searchKey: '',
			multiSetModel: false,
			multiType: 3,
			multiObj: {
				maxValue: '',
				freightMoney: '',
				stepValue: '',
				stepMoney: '',
				topOffRadio: '1',
				freeMoney: ''
			},
			multiData: {
				freeMoney: '',
				multiList: [{
					minValue: 0,
					maxValue: '',
					freightMoney: '',
					stepValue: '',
					stepMoney: ''
				}]
			}
		}
	},
	created () {
		this.$fxEventBus.$emit('setMenu', '2-4')
		this.getAuthority('01_0003_0000_00')
		if (this.$route.query.id) {
			this.id = this.$route.query.id
			this.get()
		}
	},
	// beforeRouteLeave (to, from, next) {
	// 	let that = this
	// 	if (this.isChanged) {
	// 		this.$confirm('修改尚未保存，是否退出？', '提示', {
	// 			confirmButtonText: '保存并退出',
	// 			cancelButtonText: '直接退出',
	// 			type: 'warning',
	// 			closeOnClickModal: false
	// 		}).then(() => {
	// 			this.submitForm().then(res => {
	// 				next()
	// 			}).catch(res => {
	// 				that.$fxEventBus.$emit('setMenu', '2-8')
	// 				this.$nextTick(() => {
	// 					that.$fxEventBus.$emit('setMenu', '2-4')
	// 				})
	// 			})
	// 		}).catch(() => {
	// 			next()
	// 		})
	// 	} else {
	// 		next()
	// 	}
	// },
	methods: {
		handleSelectionChange (data) {
			// this.tableSelectUtils.selectToggle(this.tableData, data)
			// let value = this.tableSelectUtils.getSelectRows()
			let ids = data.filter(item => {
				return item.productAttrplanId
			}).map(e => {
				return e.productAttrplanId
			})
			// console.log(ids)
			this.selectIds = ids
			// this.areaTableData.forEach(item => {
			// 	if (!item.productAttrplanId) {
			// 		this.$refs.table.toggleRowSelection(item, false)
			// 	}
			// })
			// this.$emit('selectIds', ids)
		},
		searchClick () {
			// console.log(this.areaTableData, this.searchKey)
			this.areaTableData.forEach(item => {
				item.searchShow = !item.productName || item.productName.includes(this.searchKey) || item.productCode.includes(this.searchKey) || item.productMatchCode.includes(this.searchKey) || item.categoryName.includes(this.searchKey)
			})
			this.colspanData()
		},
		rowShowStyle (data) {
			if (!data.row.searchShow) {
				let style = {
					'display': 'none'
				}
				return style
			} else {
				let style = {
					'display': 'table-row'
				}
				return style
			}
		},
		multiClose () {
			this.multiType = 3
			this.multiObj = {
				maxValue: '',
				freightMoney: '',
				stepValue: '',
				stepMoney: '',
				topOffRadio: '1',
				freeMoney: ''
			}
			this.multiData = {
				freeMoney: '',
				multiList: [{
					minValue: 0,
					maxValue: '',
					freightMoney: '',
					stepValue: '',
					stepMoney: ''
				}]
			}
		},
		multiDdelete () {
			if (this.selectIds.length === 0) {
				this.$message.warning('未勾选需要处理的数据，请勾选')
				return false
			}
			let mulData = this.$fxUtils.deepClone(this.areaTableData)
			for (let i = 0; i < mulData.length; i++) {
				let e = mulData[i]
				if (this.selectIds.indexOf(e.productAttrplanId) !== -1) {
					mulData.splice(i, 1)
					i--
				}
			}
			this.areaTableData = mulData
			this.colspanData()
		},
		multiSet () {
			if (this.selectIds.length === 0) {
				this.$message.warning('未勾选需要处理的数据，请勾选')
				return false
			}
			this.multiSetModel = true
		},
		saveMulti () {
			if (this.multiType === 3 || this.multiType === 8) {
				if (this.multiObj.freightMoney === '' || this.multiObj.freightMoney === null || this.multiObj.maxValue === '' || this.multiObj.maxValue === null || this.multiObj.stepValue === '' || this.multiObj.stepValue === null || this.multiObj.stepMoney === '' || this.multiObj.stepMoney === null || (this.multiObj.topOffRadio === '2' && !this.multiObj.freeMoney)) {
					this.$message.error('请输入计费规则！')
					return false
				}
				this.areaTableData.forEach(item => {
					if (this.selectIds.indexOf(item.productAttrplanId) !== -1 && item.productName) {
						item.freightTemplatePricingDTOList[0].maxValue = this.multiObj.maxValue
						item.freightTemplatePricingDTOList[0].freightMoney = this.multiObj.freightMoney
						item.freightTemplatePricingDTOList[0].stepValue = this.multiObj.stepValue
						item.freightTemplatePricingDTOList[0].stepMoney = this.multiObj.stepMoney
						item.topOffRadio = this.multiObj.topOffRadio
						item.freeMoney = item.topOffRadio === '1' ? null : this.multiObj.freeMoney
						item.pricingType = this.multiType
					}
				})
			}
			if (this.multiType === 4) {
				const item = this.multiData.multiList
				for (let j = 0; j < item.length; j++) {
					const e = item[j]
					if (e.maxValue && +e.maxValue <= +e.minValue) {
						this.$message.error('请设置大于起始数量的数值！')
						return false
					} else if (e.freightMoney === '' || e.freightMoney === null) {
						this.$message.error('请输入计费规则！')
						return false
					}
				}
				this.areaTableData.forEach(item => {
					if (this.selectIds.indexOf(item.productAttrplanId) !== -1 && item.productName) {
						item.freightTemplatePricingDTOList = this.multiData.multiList
						item.freeMoney = this.multiData.freeMoney
						item.pricingType = this.multiType
					}
				})
			}
			this.multiSetModel = false
			this.selectIds = []
			this.$refs.table.clearSelection()
		},
		changeHandle () {
			this.isChanged = true
		},
		deleteProduct (index) {
			this.areaTableData.splice(index, 1)
			this.colspanData()
		},
		addProduct (row, index) {
			let arr = []
			this.areaTableData.forEach(e => {
				if (e.productAttrplanId) {
					arr.push(e.productAttrplanId)
				}
			})
			this.addIndex = index
			this.planIds = arr
			this.addProductModel = true
		},
		getAuthority (pid) {
			let params = {
				pId: pid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
					// console.log(this.AuthorityList)
					let add = window.sessionStorage.getItem('addFreight')
					if (add === 'true') {
						if (this.AuthorityList['01_0003_0002_00']) {
							this.isDisabled = false
						} else {
							this.isDisabled = true
						}
					} else {
						if (this.AuthorityList['01_0003_0001_00']) {
							this.isDisabled = false
						} else {
							this.isDisabled = true
						}
					}
				}
			})
		},
		checkboxClassName ({ row }) {
			if (!row.productName) {
				return 'tb_cell'
			}
		},
		delTimeClick (index, Index) {
			this.areaTableData[Index].freightTemplatePricingDTOList.splice(index, 1)
		},
		addTimeClick (value, Index) {
			let row = {
				minValue: value,
				maxValue: '',
				freightMoney: '',
				freightRatio: '',
				isError: -1
			}
			this.areaTableData[Index].freightTemplatePricingDTOList.push(row)
		},
		multiDelClick (index) {
			this.multiData.multiList.splice(index, 1)
		},
		multiAddClick (value) {
			let row = {
				minValue: value,
				maxValue: '',
				freightMoney: '',
				stepValue: '',
				stepMoney: ''
			}
			this.multiData.multiList.push(row)
		},
		checkSame (provinces) {
			let list = []
			let nameList = []
			this.areaTableData.forEach((item, index) => {
				if (item.provinces && index !== this.editIndex) {
					if (this.editIndex !== null && item.areaname === this.areaTableData[this.editIndex].areaname) {} else {
						list = list.concat(item.provinces.split(','))
					}
				}
			})
			list = this.unique(list)
			provinces.forEach(item => {
				if (list.indexOf(item) !== -1) {
					nameList.push('【' + codeToCity[item] + '】')
				}
			})
			return	nameList
		},
		unique (arr) {
			return Array.from(new Set(arr))
		},
		editTree (item, index) {
			// console.log(item, index)
			this.treeId = item.id
			this.checkedArr = item.checkedArr
			this.checkedArrHalf = item.checkedArrHalf
			this.editIndex = index
			this.showTree = true
			this.addTree = false
		},
		addClick () {
			if (!this.AuthorityList['01_0003_0002_00']) {
				return false
			}
			this.treeId = ''
			this.showTree = true
			this.addTree = true
			this.editIndex = null
		},
		addArea (data) {
			let list = this.provinceList
			let checkArr = []
			let arr = []
			let flag = true
			let checkedArrHalf = []
			for (let i = 0; i < list.length; i++) {
				if (data.checkedArr[list[i]]) {
					if (data.checkedArr[list[i]].length > 0) {
						arr.push(list[i])
						flag = flag && false
					}
					checkArr = checkArr.concat(data.checkedArr[list[i]])
				}
				if (data.checkedArrHalf[list[i]]) {
					checkedArrHalf = checkedArrHalf.concat(data.checkedArrHalf[list[i]])
				}
			}
			if (flag) {
				this.$message.error('请选择配送区域')
				return false
			}
			let allArea = [...checkArr, ...checkedArrHalf]
			let allAreaName = allArea.map((item) => {
				return codeToCity[item]
			})
			let nameList = this.checkSame(data.provinces)
			// console.log(nameList, 'nnn')
			if (nameList.length > 0) {
				this.$message.error('可配送区域' + nameList.join(',') + '已被添加')
				return false
			}
			if (this.addTree) {
				let row = {
					id: data.id,
					fixedMoney: '',
					freightTemplatePricingDTOList: [{
						id: '',
						minValue: '0.00',
						maxValue: '',
						freightMoney: '',
						freightRatio: '',
						stepValue: '',
						stepMoney: '',
						pricingType: 4
					}],
					productName: '',
					productAttrplanId: '',
					productAttrplanName: '',
					productId: '',
					topOffRadio: '1',
					freeMoney: '',
					minValue: '0.00',
					freightMoney: '',
					maxValue: '',
					stepValue: '',
					colspan: 1,
					firstCol: true,
					searchShow: true,
					stepValstepMoneyue: '',
					isError: -1,
					percentMoney: '',
					pricingType: 4,
					checkedArrHalf: data.checkedArrHalf,
					checkedArr: data.checkedArr,
					updateFullSelectedArea: checkArr,
					updateHalfSelectedArea: checkedArrHalf,
					provinces: data.provinces.join(','),
					areaname: allAreaName.join(','),
					showname: allAreaName.slice(0, 21).join(',') + '...'
				}
				this.areaTableData.push(row)
			} else {
				let oldAreaname = this.areaTableData[this.editIndex].areaname
				this.areaTableData.forEach(e => {
					if (oldAreaname === e.areaname) {
						e.provinces = data.provinces.join(',')
						e.areaname = allAreaName.join(',')
						e.showname = allAreaName.slice(0, 21).join(',') + '...'
						e.checkedArrHalf = data.checkedArrHalf
						e.checkedArr = data.checkedArr
						e.updateFullSelectedArea = checkArr
						e.updateHalfSelectedArea = checkedArrHalf
					}
				})
			}
			this.colspanData()
			this.dialogClose()
		},
		addHandle (data) {
			this.areaTableData[this.addIndex].firstCol = false
			let areaname = this.areaTableData[this.addIndex].areaname
			let showname = this.areaTableData[this.addIndex].showname
			let provinces = this.areaTableData[this.addIndex].provinces
			let updateHalfSelectedArea = this.areaTableData[this.addIndex].updateHalfSelectedArea
			let updateFullSelectedArea = this.areaTableData[this.addIndex].updateFullSelectedArea
			let checkedArr = this.areaTableData[this.addIndex].checkedArr
			let checkedArrHalf = this.areaTableData[this.addIndex].checkedArrHalf
			let arr = []
			data.forEach(e => {
				let row = {
					productName: e.productName,
					transportMode: e.transportMode,
					productAttrplanId: e.productAttrplanId,
					productAttrplanName: e.productAttrplanName,
					categoryName: e.categoryName,
					productId: e.productId,
					productCode: e.productCode,
					productMatchCode: e.productMatchCode,
					fixedMoney: '',
					freightTemplatePricingDTOList: [{
						id: '',
						minValue: '0.00',
						maxValue: '',
						freightMoney: '',
						freightRatio: '',
						stepValue: '',
						stepMoney: '',
						pricingType: 4
					}],
					minValue: '0.00',
					freightMoney: '',
					topOffRadio: '1',
					freeMoney: '',
					maxValue: '',
					stepValue: '',
					stepValstepMoneyue: '',
					isError: -1,
					percentMoney: '',
					colspan: 1,
					firstCol: false,
					searchShow: true,
					pricingType: 4,
					checkedArrHalf: checkedArrHalf,
					checkedArr: checkedArr,
					updateFullSelectedArea: updateFullSelectedArea,
					updateHalfSelectedArea: updateHalfSelectedArea,
					provinces: provinces,
					areaname: areaname,
					showname: showname
				}
				arr.push(row)
				this.selectIds.push(e.productAttrplanId)
			})
			this.areaTableData.splice(this.addIndex, 0, ...arr)
			this.colspanData()
			this.cancelProduct()
		},
		cancelProduct () {
			this.addIndex = -1
			this.addProductModel = false
			// this.tableReload()
		},
		get () {
			let params = {
				id: this.id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlSV}/order/freightTemplate/detail/get`,
				data: params
			}).then(res => {
				if (res.result) {
					this.templateName = res.data.name
					this.calcgiftFlag = res.data.calcgiftFlag
					this.modifyDate = res.data.modifyDate
					// let list = res.data.freightTemplateDetailDTOList || []
					let list = res.data.freightTemplateProductAttrplanDTOList || []
					// let newList = []
					if (list.length > 0) {
						// list.forEach((item, index) => {
						for (let i = 0; i < list.length; i++) {
							let item = list[i]
							// console.time()
							item.checkedArr = item.fullSelectedArea
							item.checkedArrHalf = item.halfSelectedArea
							let provinceList = this.provinceList
							let checkArr = []
							// let arr = []
							let checkedArrHalf = []
							for (let i = 0; i < provinceList.length; i++) {
								if (item.checkedArr[provinceList[i]]) {
									checkArr = checkArr.concat(item.checkedArr[provinceList[i]])
								}
								if (item.checkedArrHalf[provinceList[i]]) {
									checkedArrHalf = checkedArrHalf.concat(item.checkedArrHalf[provinceList[i]])
								}
							}
							item.updateFullSelectedArea = checkArr
							item.updateHalfSelectedArea = checkedArrHalf
							let nameArr = item.areaname.split(',')
							item.showname = item.areaname
							item.searchShow = true
							if (nameArr.length > 20) {
								item.showname = nameArr.slice(0, 21).join(',') + '...'
							}
							item.freeMoney = item.freightTemplatePricingDTOList[0].freeMoney
							item.topOffRadio = item.freeMoney === null ? '1' : '2'
							item.categoryName = item.bigCategoryName + (item.smallCategoryName ? '-' + item.smallCategoryName : '')
							item.colspan = 1
							item.firstCol = true
							if (i === list.length - 1) {
								let addItem = this.$fxUtils.deepClone(item)
								addItem.productName = ''
								addItem.productAttrplanId = ''
								addItem.productAttrplanName = ''
								addItem.productId = ''
								addItem.categoryName = ''
								list.push(addItem)
								break
							} else {
								if (item.areaname !== list[i + 1].areaname) {
									let addItem = this.$fxUtils.deepClone(item)
									addItem.productName = ''
									addItem.productAttrplanId = ''
									addItem.productAttrplanName = ''
									addItem.productId = ''
									addItem.categoryName = ''
									list.splice(i + 1, 0, addItem)
									i++
								}
							}
						}
					}
					this.areaTableData = list
					console.log(this.areaTableData, 1233)
					this.colspanData()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		tableReload () {
			let params = {
				targettype: this.targettype,
				id: this.id,
				size: this.page.size,
				page: this.page.num
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/freightTemplate/bindData/list`,
				data: params
			}).then(res => {
				if (res.result === true) {
					if (this.targettype === 1) {
						this.productTableData = res.data.data
					} else {
						this.shopTableData = res.data.data
					}
					this.totalCount = res.data.dataCount
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		dialogClose () {
			this.showTree = false
			this.addTree = false
		},
		objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
			if (columnIndex === 0) {
				if (row.firstCol) {
					return {
						rowspan: 1,
						colspan: 1
					}
				} else if (row.colspan && row.colspan !== 1) {
					return {
						rowspan: row.colspan,
						colspan: 1
					}
				} else {
					return {
						rowspan: 0,
						colspan: 0
					}
				}
			}
		},
		colspanData () {
			// let copyData = this.$fxUtils.deepClone(this.areaTableData)
			// copyData[0].colspan = 1
			// copyData[0].firstCol = true
			// let num = 1
			// for (let i = 1; i < copyData.length; i++) {
			// 	let item = copyData[i]
			// 	item.colspan = 1
			// 	item.firstCol = true
			// 	if (item.areaname === copyData[i - 1].areaname) {
			// 		copyData[i - num].colspan = copyData[i - num].colspan + 1
			// 		copyData[i - num].firstCol = false
			// 		item.firstCol = false
			// 		num += 1
			// 	} else {
			// 		num = 1
			// 	}
			// }
			// console.log(this.sortClass(this.areaTableData))
			let copyData = this.sortClass(this.areaTableData)
			copyData.forEach(item => {
				if (item.length === 1) {
					item[0].colspan = 1
					item[0].firstCol = true
				} else {
					let num = 0
					let index = 0
					item.forEach((e, eIndex) => {
						e.colspan = 1
						e.firstCol = false
						if (e.searchShow) {
							item[index].colspan = item[index].colspan + num
							if (num === 0) {
								if (eIndex === item.length - 1) {
									e.firstCol = true
								} else {
									index = eIndex
									num = 1
								}
							}
						}
					})
				}
			})
			let finalData = []
			copyData.forEach(item => {
				finalData.push(...item)
			})
			this.areaTableData = finalData
			// console.log(this.areaTableData)
			this.$nextTick(() => {
				this.$refs.table.doLayout()
				this.areaTableData.forEach(item => {
					if (this.selectIds.indexOf(item.productAttrplanId) !== -1) {
						this.$refs.table.toggleRowSelection(item, true)
					}
				})
			})
		},
		sortClass (sortData) {
			const groupBy = (array, f) => {
				let groups = {}
				array.forEach((o) => {
					let group = JSON.stringify(f(o))
					groups[group] = groups[group] || []
					groups[group].push(o)
				})
				return Object.keys(groups).map((group) => {
					return groups[group]
				})
			}
			const sorted = groupBy(sortData, (item) => {
				return item.areaname // 返回需要分组的对象
			})
			return sorted
		},
		submitForm () {
			return new Promise((resolve, reject) => {
				let error = 'error'
				if (!this.templateName) {
					this.$message.error('模板名称不能为空！')
					reject(error)
					return false
				}
				// console.log(this.areaTableData)
				let isError = false
				for (let index = 0; index < this.areaTableData.length; index++) {
					const item = this.areaTableData[index]
					if (item.productName) {
						if (item.pricingType === 3 || item.pricingType === 8) {
							if (item.freightTemplatePricingDTOList[0].freightMoney === '' || item.freightTemplatePricingDTOList[0].freightMoney === null || item.freightTemplatePricingDTOList[0].maxValue === '' || item.freightTemplatePricingDTOList[0].maxValue === null || item.freightTemplatePricingDTOList[0].stepValue === '' || item.freightTemplatePricingDTOList[0].stepValue === null || item.freightTemplatePricingDTOList[0].stepMoney === '' || item.freightTemplatePricingDTOList[0].stepMoney === null || (item.topOffRadio === '2' && !item.freeMoney)) {
								isError = true
							}
							if (+item.freightTemplatePricingDTOList[0].stepValue === 0) {
								this.$message.error('增量值不能为0！')
								reject(error)
								return false
							}
							item.freightTemplatePricingDTOList[0].minValue = 0
							item.freightTemplatePricingDTOList.length = 1
						}
						if (item.pricingType === 4) {
							const item = this.areaTableData[index].freightTemplatePricingDTOList
							for (let j = 0; j < item.length; j++) {
								const e = item[j]
								e.pricingType = this.areaTableData[index].pricingType
								if (e.maxValue && +e.maxValue <= +e.minValue) {
									this.$message.error('请设置大于起始数量的数值！')
									reject(error)
									return false
								} else if (e.freightMoney === '' || e.freightMoney === null) {
									e.isError = 1
									isError = true
								} else {
									e.isError = -1
								}
							}
						}
					}
				}
				if (isError) {
					this.$message.error('请输入计费规则！')
					reject(error)
					return false
				}
				let list = this.$fxUtils.deepClone(this.areaTableData)
				list = list.filter(e => {
					e.freightTemplatePricingDTOList.forEach(item => {
						item.pricingType = e.pricingType
						item.productId = e.productId
						item.productName = e.productName
						item.productAttrplanId = e.productAttrplanId
						item.productAttrplanName = e.productAttrplanName
						item.freeMoney = e.freeMoney
						if (item.pricingType === 3 || item.pricingType === 8) {
							item.freeMoney = e.topOffRadio === '1' ? null : e.freeMoney
						}
					})
					return e.productName
				})
				for (let i = 0; i < list.length - 1; i++) {
					let e = list[i]
					if (e.areaname === list[i + 1].areaname) {
						e.freightTemplatePricingDTOList = e.freightTemplatePricingDTOList.concat(list[i + 1].freightTemplatePricingDTOList)
						list.splice(i + 1, 1)
						i--
					}
				}
				if (list.length === 0) {
					this.$message.error('请添加商品！')
					reject(error)
					return false
				}
				let logger
				if (this.id) {
					// logger = this.$fxLogger.createInfo('seller.freight.update', { name: this.templateName })
					logger = `编辑运费模板,模板名称:${this.templateName}`
				} else {
					// logger = this.$fxLogger.createInfo('seller.freight.add', { type: '特殊商品计费模板', name: this.templateName })
					logger = `新增特殊商品计费模板,模板名称:${this.templateName}`
				}
				let url = window.location.href.split('?')[0]
				url = url.replace(window.location.origin, '').substring(1)
				let params = {
					id: this.id,
					type: 1,
					name: this.templateName,
					calcgiftFlag: this.calcgiftFlag,
					freightTemplateDetailDTOList: list,
					logMessage: {
						message: logger,
						referer: url
					}
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIV}/shop/freightTemplate/save`,
					data: params
				}).then(res => {
					if (res.result) {
						this.$message.success('保存成功')
						this.$router.push('/main/freight')
						// this.id = res.data
						// this.get()
						this.isChanged = false
						resolve('success')
					} else {
						this.$message.error(res.msg)
						reject(error)
					}
				})
			})
		},
		areaChange (row, key, i) {
			if (this.areaTableData[i][key] === '' || this.areaTableData[i][key] < 0 || parseFloat(this.areaTableData[i][key]).toString() === 'NaN') {
				this.areaTableData[i][key] = 0
			} else if (this.areaTableData[i][key] > 9999999.99 && (key === 'percentMoney' || key === 'freightstep')) {
				this.areaTableData[i][key] = '9999999.99'
			} else {
				this.areaTableData[i][key] = this.$fxUtils.toFixedSHW(this.areaTableData[i][key], 2)
			}
			row.isError = -1
			this.changeHandle()
		},
		stepMoneyChange (index, Index, key, isWeight) {
			// console.log(isWeight)
			let item = this.areaTableData[Index].freightTemplatePricingDTOList[index][key]
			// console.log(item)
			if (item === '' || item < 0 || parseFloat(item).toString() === 'NaN') {
				this.areaTableData[Index].freightTemplatePricingDTOList[index][key] = '0.00'
			} else if (item > 9999999.999) {
				if (isWeight) {
					this.areaTableData[Index].freightTemplatePricingDTOList[index][key] = '9999999.999'
				} else {
					this.areaTableData[Index].freightTemplatePricingDTOList[index][key] = '9999999.99'
				}
			} else {
				if (isWeight) {
					this.areaTableData[Index].freightTemplatePricingDTOList[index][key] = this.$fxUtils.toFixedSHW(item, 3)
				} else {
					this.areaTableData[Index].freightTemplatePricingDTOList[index][key] = this.$fxUtils.toFixedSHW(item, 2)
				}
			}
			this.areaTableData[Index].freightTemplatePricingDTOList[index].isError = -1
			this.changeHandle()
		},
		multiListChange (index, key) {
			let item = this.multiData.multiList[index][key]
			if (item === '' || item < 0 || parseFloat(item).toString() === 'NaN') {
				this.multiData.multiList[index][key] = '0.00'
			} else if (item > 9999999.999) {
				this.multiData.multiList[index][key] = '9999999.99'
			} else {
				this.multiData.multiList[index][key] = this.$fxUtils.toFixedSHW(item, 2)
			}
		},
		weightMoneyChange (Index, key, isWeight) {
			let item = this.areaTableData[Index].freightTemplatePricingDTOList[0][key]
			if (item === '' || item < 0 || parseFloat(item).toString() === 'NaN') {
				this.areaTableData[Index].freightTemplatePricingDTOList[0][key] = '0.00'
			} else if (item > 9999999.999) {
				if (isWeight) {
					this.areaTableData[Index].freightTemplatePricingDTOList[0][key] = '9999999.999'
				} else {
					this.areaTableData[Index].freightTemplatePricingDTOList[0][key] = '9999999.99'
				}
			} else {
				if (isWeight) {
					this.areaTableData[Index].freightTemplatePricingDTOList[0][key] = this.$fxUtils.toFixedSHW(item, 3)
				} else {
					this.areaTableData[Index].freightTemplatePricingDTOList[0][key] = this.$fxUtils.toFixedSHW(item, 2)
				}
			}
			this.areaTableData[Index].freightTemplatePricingDTOList[0].isError = -1
			this.changeHandle()
		},
		multiObjChange (key) {
			let item = this.multiObj[key]
			if (item === '' || item < 0 || parseFloat(item).toString() === 'NaN') {
				this.multiObj[key] = '0.00'
			} else if (item > 9999999.999) {
				this.multiObj[key] = '9999999.99'
			} else {
				this.multiObj[key] = this.$fxUtils.toFixedSHW(item, 2)
			}
		},
		freeMoneyChange (Index) {
			let item = this.areaTableData[Index].freeMoney
			if (item > 9999999.99) {
				this.areaTableData[Index].freeMoney = '9999999.99'
			} else {
				this.areaTableData[Index].freeMoney = this.$fxUtils.toFixedSHW(item, 2)
			}
		},
		multiFChange () {
			let item = this.multiData.freeMoney
			if (item > 9999999.99) {
				this.multiData.freeMoney = '9999999.99'
			} else {
				this.multiData.freeMoney = this.$fxUtils.toFixedSHW(item, 2)
			}
		},
		deleteClick (id, index) {
			this.$confirm('是否要删除？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				let params = {
					id: id
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIV}/shop/freight/detail/remove`,
					data: params
				}).then(res => {
					if (res.result) {
						this.$message.success('删除成功')
						this.areaTableData.splice(index, 1)
					} else {
						this.$message.error(res.msg)
					}
				})
			}).catch(() => {})
		},
		goBack () {
			this.$router.push('/main/freight')
		}
	}
}
</script>

<style  lang="stylus" scoped>
.store-name {
	border-bottom: 1px solid #dce2fd;
	height:66px;
	min-height: 66px;
	line-height: 66px;
	box-sizing border-box
	span {
		font-size: 18px;
		font-weight: bold
		float left
		display inline-block
		line-height 66px
		padding-right 20px
		i {
			border-radius: 50%;
			background: #9da6af;
			padding: 3px;
			cursor: pointer;
		}
		.el-icon-back:before {
			content: "\E6EA";
			color: #fff;
			font-weight: bold;
		}
	}
}
.container{
    overflow :auto;
    text-align :left;
    box-sizing :border-box;
    width :100%;
    padding-top :10px;
    height:calc(100% - 120px);
	font-size: 14px;
	.template-name {
		display: flex;
		align-items: center;
		.name-input {
			width: 250px;
			margin: 0 30px 0 10px;
		}
		.edit-time {
			margin-left: auto;
			color: #999;
			margin-right: 50px;
		}
	}
	.search-input {
		width: 360px;
		float: right
	}
	.btn-feight-box{
        margin 10px;
		display: flex
    }
    .table-box{
		flex: 1;
		min-height: 0;
        margin-top :10px;
		.table-wrap {
			height: 100%;
			overflow: hidden;
			overflow-y: auto;
			// display: flex;
			// flex-direction: column;
		}
        .freight-table-head {
			width: 100%;
			display: flex;
			height: 40px;
			line-height: 40px;
			.flex-one, .flex-two, .flex-four {
				text-align: center;
				height: 100%;
				background: #F7F7F7;
			}
		}
		.freight-content-wrap {
			// flex: 1;
			// overflow: hidden;
			// overflow-y: auto;
		}
		.freight-table-content {
			width: 100%;
			display: flex;
			// align-items: center;
			.flex-one {
				display: flex;
				align-items: center;
				justify-content: center;
				border-top: 0
			}
			.flex-four {
				display: flex;
				align-items: center;
				justify-content: center;
				border-top: 0;
				border-right: 0
			}
			.flex-two {
				padding: 10px 0;
				border-top: 0
			}
			.flex-three {
				display: flex;
				align-items: center;
				padding-left: 15px;
				box-sizing: border-box
			}
		}
		.flex-one {
			flex: 3;
			border: 1px solid #D5D5D5;
			box-sizing: border-box;
			border-right: 0
		}
		.flex-four {
			flex: 1.5;
			border: 1px solid #D5D5D5;
			box-sizing: border-box
		}
		.flex-two {
			flex: 5;
			border: 1px solid #D5D5D5;
			box-sizing: border-box
		}
		.flex-three {
			width: 150px
		}
        .grid-content{
            box-sizing :border-box;
            height :100%;
            overflow-y :auto
        }
		.cell-input{
            width :120px;
			margin: 0 10px;
        }
		.rule-box {
			text-align: left;
			padding-left: 20px
			.two-wrap:last-of-type {
				.step-box {
					margin-bottom: 0
				}
			}
			.step-box {
				margin-bottom: 10px;
				.cell-input{
					width :100px;
					margin: 0 6px;
				}
			}
			.time-btn{
				padding:2px !important
				&:first-of-type {
					margin-left: 10px
				}
			}
		}
    }
    .time-box{
        width:300px;
        height :40px;
        line-height :40px;
        margin-left:80px;
    }
	.freight-type {
		display: flex
		align-items: center
		margin-top: 10px
		border-left: 4px solid var(--fx-primary-color);
		img {
			width: 25px;
			height: 25px
		}
		.type-title {
			font-size: 16px
			margin: 0 30px 0 10px;
		}
		.type-effect {
			color: var(--fx-primary-color);
			margin-left: 30px;
		}
	}
	.choose-text {
		margin: 15px 0 10px;
	}
	.type-text {
		color: #999;
		margin-left: 15px
	}
	.method-box {
		display: flex;
		width: 300px;
		height: 90px;
		border: 1px solid #eee;
		border-radius: 10px;
		padding: 15px 20px;
		box-sizing: border-box;
		color: #999;
		cursor: pointer;
		margin-right: 30px;
		img {
			width: 28px;
			height: 28px;
			margin-right: 10px;
		}
		.method-p {
			margin: 5px 0 10px;
			font-weight: bold;
		}
		.method-intro {
			font-size: 13px;
		}
		&.select {
			border: 1px solid #8EB5FF;
			background-color: #F7FAFE;
			.method-p {
				color: var(--fx-primary-color)
			}
		}
	}
	.area-add {
		margin-left: 5px;
		cursor: pointer;
		font-size: 16px;
		color: #999;
	}
	.tip-icon {
		display: inline-block;
		cursor: pointer;
		margin-left: 10px;
	}
	.self-input{
		width :100px;
		margin: 20px 10px 0
	}
	.dialog-container{
		.input-box{
			display: flex
			align-items: center
			margin-bottom:20px;
			.input-span{
				width:180px;
				margin-left:10px
			}
			.change-title {
				margin-right: 30px;
				display: inline-block;
				vertical-align: top;
				flex-shrink: 0
			}
			.change-right {
				margin-top: 3px;
				display: inline-block;
				.pay-type-box {
					display: flex;
					flex-flow: column;
					.el-radio {
						margin-top: 20px;
						&:nth-of-type(1) {
							margin-top: 0;
						}
					}
				}
				.cell-input {
					width: 100px;
					margin: 0 6px;
				}
			}
		}
	}
}
</style>
<style lang="stylus">
.el-dialog__body{
    padding:0px 20px 20px 20px
}
.flag-switch .el-switch__label {
	position: absolute;
	display: none;
	color: #fff;
}
.input-error .el-input__inner {
	border-color: #F56C6C;
}
/*打开时文字位置设置*/
.flag-switch .el-switch__label--right {
	z-index: 1;
	right: -7px;
}
/*关闭时文字位置设置*/
.flag-switch .el-switch__label--left {
	z-index: 1;
	left: 20px;
}
/*显示文字*/
.flag-switch .el-switch__label.is-active {
	display: block;
}
.flag-switch.el-switch .el-switch__core, .el-switch .el-switch__label {
	width: 40px !important;
}
.method-intro {
	.el-radio__label,.el-radio__input.is-checked+.el-radio__label {
		color: #333;
	}
}
.el-tooltip__popper.is-dark.tip-class {
	width: 250px
}
.tb_cell .el-checkbox__input {
	display: none
}
</style>
